export default "/assets/images/outdoor-aqi-video-thumbnail.8fd59903a6c2299d.jpg";